import { Component, OnInit } from '@angular/core';
import { AdminServicesService } from '../../admin-services.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-leads-history-admin',
  templateUrl: './leads-history-admin.component.html',
  styleUrls: ['./leads-history-admin.component.css']
})
export class LeadsHistoryAdminComponent implements OnInit {
  p: number = 1;
  public ID: any;
  public collection: any;
  term: string;
  constructor(public admin: AdminServicesService,
    public router: Router,
    public toastr: ToastrService) {
    this.ID = JSON.parse(localStorage.getItem('userDetails'));
  }

  ngOnInit(): void {
    let obj = {
      "user_id": `${this.ID.userId}`
    }
    this.admin.leadHistory(obj).subscribe((res: any) => {
      if (res.code === 200) {
        this.collection = res.data;
      }
    });
  }
}
